var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-item-table-cell-edit",class:{ 'form-item-table-cell-edit--select': _vm.isSelectCell }},[_c(_vm.componentName,_vm._b({tag:"component",on:{"change":_vm.onChange}},'component',_vm.formDataForEdit,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }